import { MapPin, Mail, MessageCircle, Phone } from "lucide-react";
import { useState } from "react";

export default function ContactUs() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    number: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data Submitted:", formData);
  };

  return (
    <div className="min-h-screen bg-white relative">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(0,0,0,0.1)_1px,transparent_1px)] [background-size:20px_20px]"></div>

      <div className="relative max-w-7xl mx-auto py-16 px-6 text-center">
        <h2 className=" text-3xl md:text-5xl font-bold text-gray-900 md:mt-20">Get in Touch</h2>
        <p className="text-gray-600 mt-4 text-lg">
          Have questions or need assistance? Reach out to us through any of the options below or fill out the form.
        </p>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mt-10">
          {[
            {
              icon: <MessageCircle />,
              title: "WhatsApp",
              text: "Chat with us",
              action: "Message Now",
              link: "https://wa.me/+16479601930",
            },
            {
              icon: <MapPin />,
              title: "Location",
              text: "41 Deforest Dr, Brampton ON L7A 2Y1, Canada",
              action: "View on Map",
              link: "https://maps.google.com?q=41+Deforest+Dr+Brampton+ON",
            },
            {
              icon: <Phone />,
              title: "Call Us",
              text: "+1 647 960 1930",
              action: "Call Now",
              link: "tel:6479601930",
            },
            {
              icon: <Mail />,
              title: "Email",
              text: "Pankajaggarwaltaxguy@gmail.com",
              action: "Send Email",
              link: "mailto:Pankajaggarwaltaxguy@gmail.com",
            },
          ].map((item, index) => (
            <div
              key={index}
              className="bg-white p-6 md:w-[300px] gap-12 rounded-lg shadow-lg text-center border border-gray-200 flex flex-col justify-between h-full"
            >
              <div>
                <div className="text-4xl text-black mb-4">{item.icon}</div>
                <h3 className="text-xl font-semibold text-gray-900">{item.title}</h3>
                <p className="text-gray-600 text-md mt-2 break-words">{item.text}</p>
              </div>
              <a href={item.link} target="_blank" rel="noopener noreferrer" className="mt-4">
                <button className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-700 transition">
                  {item.action}
                </button>
              </a>
            </div>
          ))}
        </div>

        {/* Contact Form */}
        <h1 className=" text-3xl md:text-5xl font-bold mt-20">Message Us</h1>
        <p className="mt-3">We’ll get back to you within 24 hours</p>

        <form onSubmit={handleSubmit} className="mt-12 bg-white p-8 rounded-lg shadow-lg max-w-3xl mx-auto border border-gray-200">
          {/* First Name & Last Name */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <input
              type="text"
              name="firstName"
              placeholder="First Name"
              className="p-3 border border-gray-300 rounded w-full"
              onChange={handleChange}
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last Name"
              className="p-3 border border-gray-300 rounded w-full"
              onChange={handleChange}
            />
          </div>

          {/* Email & Phone Number */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
            <input
              type="email"
              name="email"
              placeholder="Email"
              className="p-3 border border-gray-300 rounded w-full"
              onChange={handleChange}
            />
            <input
              type="tel"
              name="number"
              placeholder="Phone Number"
              className="p-3 border border-gray-300 rounded w-full"
              onChange={handleChange}
            />
          </div>

          {/* Message Field */}
          <textarea
            name="message"
            placeholder="Your Message"
            className="p-3 border border-gray-300 rounded w-full mt-4"
            rows="4"
            onChange={handleChange}
          ></textarea>

          {/* Submit Button */}
          <button type="submit" className="mt-6 bg-gray-500 text-white px-6 py-3 rounded w-full hover:bg-gray-700 transition">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}
